import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataSharingService } from '../data-sharing.service';

@Component({
  selector: 'pm-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.css']
})
export class ErrorModalComponent implements OnInit {

  @Input() reportTile: boolean;
  @Input() modalText: string; // Defines the title of the modal
  @Input() modcontent: string; // Defines the content of the modal
  // Defines the enable/disable of the button
  @Input() removeBtn: boolean;
  @Output('cancelModal') cancelModal = new EventEmitter<any>(); // Emits the cancel event of the modal
  @Output() deleteModal = new EventEmitter<any>(); // Emits the delete event of the modal
  @Input() localDriverBtn: boolean;
  dialog: any;
  selectedFile: any;
  message: string;
  constructor(public activeModal: NgbActiveModal, private _data: DataSharingService) {
  }

  ngOnInit() {
    this._data.FileName.subscribe(message => this.message = message);
  }
   public delete() {
    this.deleteModal.emit({});
    this.activeModal.close();
    this._data.changeValue('');
  }
}

